import { getApps, initializeApp } from "firebase/app";
import {
  getAuth,
  browserLocalPersistence,
  connectAuthEmulator,
} from "firebase/auth";
import isEmpty from "lodash/isEmpty";

export const initFirebase = () => {
  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    // databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  };

  // Initialize Firebase
  if (isEmpty(getApps())) initializeApp(firebaseConfig);

  const auth = getAuth();

  auth.setPersistence(browserLocalPersistence);

  if (process.env.NEXT_PUBLIC_ENV) return;

  return connectAuthEmulator(auth, "http://127.0.0.1:9099", {
    disableWarnings: true,
  });
};
